import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

/**
 * `Validators.required` that treats a whitespace-only string as missing.
 *
 * Old CMT's AngularJS `ng-model` trims text input by default (`ng-trim`), so `"  "` never
 * satisfied `ng-required` there. Plain `Validators.required` accepts it, which let a blank
 * street pass the form while the address check (which trims) stayed `incomplete` — a submit
 * click then did nothing (EB-3809 PR review). Non-string values (e.g. a picked autocomplete
 * object) fall through to `Validators.required`.
 * @ticket EB-3809
 */
export function requiredTrimmed(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (typeof value === 'string') return value.trim() ? null : { required: true };
  return Validators.required(control);
}
